import * as moment from 'moment';

export const convertTimeStampToDate = (timeStampDate) => {
  if (timeStampDate) {
    return moment(timeStampDate).format(
      timeStampDate.length > 10 ? 'Do MMM YYYY, h:mm a' : 'Do MMM YYYY',
    );
  } else {
    return '';
  }
};
